import { createContext, useContext } from "react";

export type StreamState = "connecting" | "connected" | "reconnecting" | "stale" | "disconnected";
export interface StreamValue {
  state: StreamState;
  lastEventAt: string | null;
  active?: boolean;
  activation?: number;
  eventActivation?: number | null;
}
export const StreamContext = createContext<StreamValue>({ state: "connecting", lastEventAt: null });
export const useEventStream = () => useContext(StreamContext);
